enum ConsentType {
  COMMUNICATION = 'communication',
  HAS_NOTES = 'hasNotes',
}
export default ConsentType;
